/**
 * @file utils/cn.js
 * Utility per combinare classi CSS condizionali con merge Tailwind.
 * Combina clsx (classi condizionali) e tailwind-merge (risolve conflitti Tailwind).
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
